<template>
  <div>
    <!-- Filter -->
    <modern-filter-bar
      embedded
      single-line
      inline-period
      :show-timeseries="false"
      :show-period="true"
      :start-date.sync="filter.start_date"
      :end-date.sync="filter.end_date"
      @period-search="filterByPeriode"
      @period-reset="resetFilterPeriode"
      :search-text.sync="filter.patient_name"
      @search-keyup="filterByPatient"
      search-placeholder="Cari Nama Pasien..."
    >
      <template #before-search v-if="!hasPatient && currentUser.user_type_id != 1">
        <div class="modern-filter-select">
          <treeselect
            v-model="filter.doctor_id"
            :multiple="false"
            :options="doctors"
            placeholder="Semua dokter"
            @select="filterByDoctor"
          />
        </div>
      </template>
    </modern-filter-bar>

    <!-- Table -->
    <medhop-data-table
      summary-title="Daftar Resep Obat"
      striped
      class="mt-3"
      hover
      :items="items"
      :fields="fields"
      :style="'white-space: nowrap'"
      responsive
    >
      <template #cell(date)="data">
        {{ data.item.date.split(" ")[0] }}
      </template>
      <template #cell(doctor_name)="data">
        {{ data.item.doctor_name }}
      </template>
      <template #cell(display_medicine)="data">
        <table class="table">
          <tr>
            <th>Obat</th>
            <th>Dosis</th>
            <th>Frekuensi</th>
            <th>Hari</th>
            <th>Instruksi</th>
          </tr>
          <tr
            v-for="(medicine, index) in data.item.display_medicine"
            :key="index"
          >
            <td>{{ medicine.name }}</td>
            <td>{{ medicine.dosage }}</td>
            <td>{{ medicine.frequency }}</td>
            <td>{{ medicine.days }}</td>
            <td>{{ medicine.instruction }}</td>
          </tr>
        </table>
      </template>
      <template #cell(patient_name)="data">
        <span v-if="data.item.sub_patient_id == null">
          {{ data.item.patient_name }}
        </span>
        <span v-if="data.item.sub_patient_id != null">
          {{ data.item.patient_name + " - " + data.item.sub_patient_name }}
        </span>
      </template>

      <template #cell(redeem_type)="data">
        <b-badge
          style="background-color: #f47b20; color: #ffffff"
          pill
          v-if="data.item.redeem_type == 0"
          >Internal (Pembayaran)</b-badge
        >
        <b-badge
          pill
          style="background-color: var(--skin-primary); color: #ffffff"
          v-if="data.item.redeem_type == 1"
          >Internal (Apotek)</b-badge
        >
        <b-badge
          style="background-color: #ffffff"
          pill
          v-if="data.item.redeem_type == 2"
          >Eksternal</b-badge
        >
      </template>

      <template #cell(redeem_status_display)="data">
        <template v-if="data.item.redeem_type != 2">
          <b-badge
            pill
            style="background-color: #ffc107"
            v-if="data.item.redeem_status == 0"
            >{{ data.item.redeem_status_display }}</b-badge
          >
          <b-badge
            pill
            style="background-color: #28a745; color: #ffffff"
            v-if="data.item.redeem_status == 1"
            >{{ data.item.redeem_status_display }}</b-badge
          >
        </template>
        <template v-else> - </template>
      </template>
      <template #cell(visit_status_display)="data">
        <b-badge
          pill
          :class="data.item.can_confirm_discharge ? 'badge-light-warning' : 'badge-light-success'"
        >
          {{ data.item.can_confirm_discharge ? 'Menunggu konfirmasi pulang' : data.item.visit_status_display }}
        </b-badge>
      </template>
      <!-- <template #cell(display_medicine)="data">
        {{ displayMedicine(data.item.display_medicine) }}
      </template> -->
      <template #cell(actions)="data">
        <b-button
          v-if="!selectPrescription && data.item.can_confirm_discharge"
          class="prescription-discharge-button mr-1"
          v-b-tooltip.hover
          title="Konfirmasi obat sudah diterima dan pasien pulang"
          @click="confirmPatientDischarge(data.item)"
        >
          <i class="fas fa-home"></i><span>Konfirmasi Pulang</span>
        </b-button>
        <template
          v-if="
            !selectPrescription &&
            data.item.redeem_status == 0 &&
            data.item.redeem_type != 2 && pharmacyAccess == true
          "
        >
          <b-button
            size="sm"
            class="mr-1 btn-primary text-center"
            variant="primary"
            v-b-tooltip.hover
            title="Pembayaran Obat"
            @click="btnSelectedItem(data.item.id, data.item.redeem_type)"
            ><i class="fas fa-cash-register"></i
          ></b-button>
        </template>
        <template v-if="hasPatient && !selectPrescription">
          <b-button
            size="sm"
            class="mr-1 btn-success"
            v-b-tooltip.hover
            title="Detail"
            @click="historyDetailPage ? $router.push('/prescriptions/detail/' + data.item.id) : btnDetailOnClick(data.item.id)"
            ><i class="fas fa-eye px-0"></i
          ></b-button>
          <b-button
            size="sm"
            class="btn-info"
            v-b-tooltip.hover
            title="Download"
            @click="btnDownloadOnClick(data.item.id)"
            ><i class="fas fa-download px-0"></i
          ></b-button>
        </template>
        <template v-if="selectPrescription">
          <b-button
            size="sm"
            class="mr-1 btn-primary"
            variant="primary"
            @click="selectedItem(data.item.id)"
            >Pilih</b-button
          >
        </template>
        <template v-if="!hasPatient && !selectPrescription">
          <b-button
            size="sm"
            class="mr-1 btn-info"
            v-b-tooltip.hover
            title="Detail"
            @click="
              $router.push({ path: '/prescriptions/detail/' + data.item.id })
            "
            ><i class="fas fa-eye px-0"></i
          ></b-button>
          <b-button
            size="sm"
            class="mr-1 btn-success"
            v-b-tooltip.hover
            title="Edit"
            v-if="manipulateBtn == true"
            @click="
              $router.push({ path: '/prescriptions/edit/' + data.item.id })
            "
            ><i class="fas fa-edit px-0"></i
          ></b-button>
          <b-button
            size="sm"
            class="btn-danger"
            v-b-tooltip.hover
            title="Hapus"
            v-if="manipulateBtn == true"
            @click="btnDeleteOnClick(data.item.id)"
            ><i class="fas fa-trash px-0"></i
          ></b-button>
        </template>
      </template>
    </medhop-data-table>
    <medhop-pagination
      v-if="items.length != 0"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      @page-click="pageOnClick"
      class="mt-4"
    ></medhop-pagination>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import Treeselect from "@riophae/vue-treeselect";
import { debouncer } from "@/core/modules/Helper.js";
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import ApiService from "@/core/services/api.service.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getUser } from "@/core/services/jwt.service.js";

export default {
  props: {
    items: Array,
    fields: Array,
    hasPatient: Boolean,
    perPage: Number,
    currentPage: Number,
    totalRows: Number,
    selectPrescription: Boolean,
    historyDetailPage: Boolean,
  },

  components: {
    Card,
    Treeselect,
  },

  data() {
    return {
      // Filter
      filter: {
        doctor_id: "",
        patient_name: "",
        start_date: "",
        end_date: "",
      },
      // Options
      doctors: [],
      // access management
      manipulateBtn: false,
      pharmacyAccess: false,
      // current user
      currentUser: getUser(),
    };
  },

  methods: {
    async confirmPatientDischarge(item) {
      const confirmation = await Swal.fire({
        title: "Konfirmasi pasien pulang?",
        text: `Pastikan obat sudah diterima oleh ${item.patient_name} dan edukasi penggunaannya telah diberikan.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, pasien sudah pulang",
        cancelButtonText: "Belum",
        confirmButtonColor: "var(--skin-primary)",
      });
      if (!confirmation.value) return;

      try {
        const response = await ApiService.put(`prescriptions/${item.id}/complete-visit`, {});
        await Swal.fire(
          response.data.title || "Pasien selesai dilayani",
          response.data.message || "Pasien sudah dikonfirmasi pulang.",
          "success"
        );
        this.$emit("visit-completed");
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Status kunjungan belum dapat diselesaikan.";
        Swal.fire("Gagal", message, "error");
      }
    },
    pageOnClick(evt, page) {
      evt.preventDefault();
      this.$emit("pageOnClick", page);
    },

    async getDoctorsOption() {
      let response = await module.setDoctorTreeSelect("doctors");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.doctors = response.data;
        this.doctors.unshift({
          label: "Filter Berdasar Dokter",
          id: "",
          isDisabled: true,
        });
      }
    },

    resetFilterPeriode() {
      this.filter = validation.clearForm(this.filter);
      if (this.currentUser.user_type_id == 1) {
        this.filter.doctor_id = this.currentUser.id;
      }
      this.$emit("resetFilter", this.filter);
      this.$emit("filterByPeriode", this.filter);
    },

    filterByPeriode() {
      // if (this.filter.patient_name != "") {
      //   this.currentPage = 1
      //   }else{
      //   this.currentPage = this.lastCurrentPage
      // }
      this.$emit("filterByPeriode", this.filter);
    },

    filterByPatient() {
      // if (this.filter.patient_name != "" || this.filter.doctor_id != "" || this.filter.start_date != '' || this.filter.end_date != '') {
      //   this.currentPage = 1
      //   }else{
      //   this.currentPage = this.lastCurrentPage
      // }
      debouncer(() => {
        this.$emit("filterByPatient", this.filter);
      }, 500);
    },

    async filterByDoctor(evt) {
      // if (this.filter.patient_name != "" || this.filter.doctor_id != "" || this.filter.start_date != '' || this.filter.end_date != '') {
      //   this.currentPage = 1
      //   }else{
      //   this.currentPage = this.lastCurrentPage
      // }
      await this.filter.doctor_id;
      this.$emit("filterByDoctor", this.filter);
    },

    btnDetailOnClick(id) {
      this.$emit("btnDetailOnClick", id);
    },

    btnDownloadOnClick(id) {
      this.$emit("btnDownloadOnClick", id);
    },

    btnDeleteOnClick(id) {
      this.$emit("btnDeleteOnClick", id);
    },

    async selectedItem(id) {
      let response = await module.get("prescriptions/item/" + id);
      this.$emit("selectedItem", response, id);
    },

    async btnSelectedItem(id, type) {
      let response = await module.get("prescriptions/item/" + id);

      if (response.status_validation == 0) {
        if (type == 1) {
          window.data = response;
          window.id = id;
          this.$router.push("/pharmacy/cashier");
        } else if (type == 0) {
          this.$root.$emit("btnSelectedItem", response, id);
          this.$router.push(`/payment/add?prescription_id=${id}`);
        }
      } else {
        Swal.fire(
          "Terjadi Kesalahan",
          "Terdapat kesalahan dalam penulisan format frekuensi dosis , silahkan lakukan update atau penyesuaian untuk melanjutkan",
          "error"
        );
      }
    },

    displayMedicine(medicines) {
      let str = "";
      medicines.forEach(function (value, index) {
        str += value.name + " - " + value.dosage;
        if (index != medicines.length - 1) {
          if (medicines.length > 1) str += ", ";
        }
      });
      return str;
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "8002") {
          this.manipulateBtn = true;
        }
        if (access_right[a] == "1402") {
          this.pharmacyAccess = true;
        }
      }
    },
  },

  watch: {
    "filter.doctor_id": function (newVal, oldVal) {
      if (typeof newVal === "undefined") {
        this.filter.doctor_id = "";
        this.filterByDoctor();
      }
    },
  },

  mounted() {
    if (this.currentUser.user_type_id != 1) {
      // Get Options
      this.getDoctorsOption();
    }
    this.setActiveMenu();
  },
};
</script>

<style scoped>
.prescription-discharge-button.btn {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #8fd4ce;
  border-radius: 9px;
  background: #f2fbfa;
  color: #147f79;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.prescription-discharge-button.btn i {
  position: static !important;
  margin: 0 !important;
  color: var(--skin-primary) !important;
}
</style>

<style></style>
